import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * ThemeInitializer component
 * Responsible for initializing and applying theme settings based on saved preferences
 * Works in conjunction with ThemeContext to ensure consistent theme application
 */
export default function ThemeInitializer({ children }) {
  const { darkMode } = useTheme();
  
  useEffect(() => {
    // This effect will run when the component mounts
    // Theme application is now handled by ThemeContext
    // This component serves as an initialization layer
    const root = document.documentElement;
    
    // Apply any additional theme initializations if needed
    // For example, setting CSS variables or other theme-related configurations
    if (darkMode) {
      root.classList.add('dark-initialized');
    } else {
      root.classList.add('light-initialized');
    }
    
    return () => {
      // Cleanup if necessary
      root.classList.remove('dark-initialized', 'light-initialized');
    };
  }, [darkMode]);

  // Pass children through to render the app content
  return <>{children}</>;
}